import { ColumnDef } from '@tanstack/react-table'
import { AppTable, AppTableProps } from 'components'
import { FC } from 'react'
import { CityViewModel } from 'sdk'

interface Props extends AppTableProps<CityViewModel> {}
export const CityDataTable: FC<Props> = (props) => {
  const columns: ColumnDef<CityViewModel>[] = [
    // {
    //   header: 'Id',
    //   accessorKey: 'Id',
    // },
    {
      header: 'State',
      accessorKey: 'State',
    },
    {
      header: 'State Code',
      accessorKey: 'StateCode',
    },
    {
      header: 'City Name',
      accessorKey: 'Name',
    },
    {
      header: 'Zip Code',
      accessorKey: 'ZipCode',
    },
    {
      header: 'City Type',
      accessorKey: 'Type',
    },
    {
      header: 'Upload Date',
      accessorKey: 'UploadDate',
    },
    {
      header: 'Uploaded By',
      accessorKey: 'UploadedByName',
    },
  ]
  return (
    <>
      <AppTable columns={columns} {...props} />
    </>
  )
}
